module.exports = __webpack_public_path__ + "static/media/technique41.7d46b070.png";